import { all } from 'redux-saga/effects';

import { watchAccessVouchersActions } from './accessVouchers/saga';
import { watchUserActions } from './auth/saga';
import { watchCateringOptionsActions } from './cateringOptions/saga';
import { watchCompaniesActions } from './companies/saga';
import { watchCrewMaterialTemplatesActions } from './crewMaterialTemplates/saga';
import { watchCrewMaterialsActions } from './crewMaterials/saga';
import { watchCrewMembersActions } from './crewMembers/saga';
import { watchDepartmentsActions } from './departments/saga';
import { watchEmailTemplateTypesActions } from './emailTemplateTypes/saga';
import { watchEmailTemplatesActions } from './emailTemplates/saga';
import { watchEventMaterialsActions } from './eventMaterials/saga';
import { watchEventsActions } from './events/saga';
import { watchGatesActions } from './gates/saga';
import { watchGroupsActions } from './groups/saga';
import { watchLocationsActions } from './locations/saga';
import { watchMaterialCategoriesActions } from './materialCategories/saga';
import { watchMaterialsActions } from './materials/saga';
import { watchMediaActions } from './media/saga';
import { watchNotificationActions } from './notifications/saga';
import { watchOccupationsActions } from './occupations/saga';
import { watchParkingVouchersActions } from './parkingVouchers/saga';
import { watchParkingsActions } from './parkings/saga';
import { watchPeriodsActions } from './periods/saga';
import { watchPermissionsActions } from './permissions/saga';
import { watchPrintersActions } from './printers/saga';
import { watchProfileGroupsActions } from './profileGroups/saga';
import { watchProfilesActions } from './profiles/saga';
import { watchRegistrationsActions } from './registrations/saga';
import { watchRentalsActions } from './rentals/saga';
import { watchSafetyQuestionsActions } from './safetyQuestions/saga';
import { watchSystem } from './system/saga';
import { watchTransportVouchersActions } from './transportVouchers/saga';
import { watchUsersActions } from './users/saga';
import { watchVenuesActions } from './venues/saga';
import { watchWristbandsActions } from './wristbands/saga';
import { watchZonesActions } from './zones/saga';

export default function* rootSaga() {
  yield all([
    watchSystem(),
    watchUserActions(),
    watchGroupsActions(),
    watchUsersActions(),
    watchPermissionsActions(),
    watchVenuesActions(),
    watchNotificationActions(),
    watchZonesActions(),
    watchEventsActions(),
    watchPeriodsActions(),
    watchCompaniesActions(),
    watchMediaActions(),
    watchAccessVouchersActions(),
    watchParkingVouchersActions(),
    watchTransportVouchersActions(),
    watchProfileGroupsActions(),
    watchProfilesActions(),
    watchParkingsActions(),
    watchOccupationsActions(),
    watchCateringOptionsActions(),
    watchMaterialCategoriesActions(),
    watchMaterialsActions(),
    watchEventMaterialsActions(),
    watchSafetyQuestionsActions(),
    watchEmailTemplatesActions(),
    watchEmailTemplateTypesActions(),
    watchCrewMaterialsActions(),
    watchCrewMaterialTemplatesActions(),
    watchRegistrationsActions(),
    watchDepartmentsActions(),
    watchCrewMembersActions(),
    watchGatesActions(),
    watchLocationsActions(),
    watchRentalsActions(),
    watchPrintersActions(),
    watchWristbandsActions(),
  ]);
}
